import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { isSupabaseConfigured, supabase } from './supabase.js';
import { clearProposalDrafts } from './proposalDrafts.js';

const AuthContext = createContext({ user: null, loading: false, configured: false });
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(isSupabaseConfigured);
  useEffect(() => {
    if (!supabase) return undefined;
    let active = true;
    let currentUserId = null;
    let authEventReceived = false;
    supabase.auth.getSession().then(({ data }) => {
      if (active && !authEventReceived) { currentUserId = data.session?.user?.id || null; setUser(data.session?.user || null); setLoading(false); }
    }).catch(() => active && setLoading(false));
    const { data: listener } = supabase.auth.onAuthStateChange((_event, session) => {
      if (active) {
        authEventReceived = true;
        if (currentUserId && currentUserId !== session?.user?.id) clearProposalDrafts(currentUserId);
        currentUserId = session?.user?.id || null;
        setUser(session?.user || null);
        setLoading(false);
        window.dispatchEvent(new CustomEvent('residentservice360:session-changed', { detail: { user: session?.user || null } }));
      }
    });
    return () => { active = false; listener.subscription.unsubscribe(); };
  }, []);
  const value = useMemo(() => ({ user, loading, configured: isSupabaseConfigured }), [user, loading]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}
export function useAuth() { return useContext(AuthContext); }
